var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215.053,
    height: 32.918,
    viewBox: "0 0 215.053 32.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.362,
    y1: 0.862,
    x2: 0.75,
    y2: -0.026,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01f2b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80942",
    "data-name": "Path 80942",
    d: "M42.035,0,31.24,14.228l6.959,9.15,1.529-2.025-5.4-7.125L43.562,2.049l6.314,8.3,1.542,2.029,1.546-2.029,6.28-8.255,9.234,12.177-5.4,7.125L64.6,23.422l6.959-9.152L60.771.04H57.715l-6.3,8.274L45.087,0Z",
    transform: "translate(-31.24)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80943",
    "data-name": "Path 80943",
    d: "M152.97.2,163.8,14.428l-9.268,12.2-9.268-12.2,5.433-7.1L149.136,5.3l-5.486,7.233-1.44,1.894,1.41,1.861,9.386,12.389h3.054l10.793-14.251L156.06.2Z",
    transform: "translate(-142.21 -0.2)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1.135,
    y1: 1,
    x2: -1.127,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80944",
    "data-name": "Path 80944",
    d: "M93.942,84.054,86.13,94.369h3.054l6.3-8.288,6.327,8.327h3.056L97.022,84.057,95.48,82.024Z",
    transform: "translate(-86.13 -82.024)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -0.904,
    y1: 1,
    x2: -0.894,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80945",
    "data-name": "Path 80945",
    d: "M10.793,0,0,14.228l10.793,14.25h3.056L23.2,16.127l1.44-1.9-1.408-1.856L17.72,5.1,16.159,7.125l5.433,7.1-9.27,12.2-9.268-12.2L13.883,0Z",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0,
    y1: 1.001,
    x2: 0.008,
    y2: 1.001,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56385",
    "data-name": "Group 56385",
    transform: "translate(-36 -21.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41157",
    "data-name": "Group 41157",
    transform: "translate(-502 -218.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41156",
    "data-name": "Group 41156",
    transform: "translate(538 240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41154",
    "data-name": "Group 41154",
    transform: "translate(62.675 2.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39396_00000082369063725820569850000014136147221644146613_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79773_00000147918923915039504010000013583581780589998976_",
    d: "M620.158,383.958l-.032-17.272-8.569,14.39H610l-8.569-14.3v17.172H598.18v-23.7h2.778l9.89,16.661L620.6,360.25h2.777l.032,23.708Z",
    transform: "translate(-598.18 -360.25)",
    fill: "#171f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79774_00000182505562563589514870000005018021897153039007_",
    d: "M667.881,378.031v10.837H664.8V386.5c-1.086,1.623-3.084,2.576-5.893,2.576-4.062,0-6.638-2.167-6.638-5.286,0-2.879,1.863-5.249,7.213-5.249h5.146V377.9c0-2.741-1.592-4.332-4.812-4.332a9.074,9.074,0,0,0-5.69,1.932l-1.352-2.438a11.959,11.959,0,0,1,7.415-2.3c4.913,0,7.686,2.369,7.691,7.277m-3.258,5.355v-2.507h-5.015c-3.215,0-4.13,1.256-4.13,2.779,0,1.794,1.49,2.912,3.96,2.912a5.208,5.208,0,0,0,5.185-3.183",
    transform: "translate(-623.478 -365.16)",
    fill: "#171f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79775_00000040575768685372459710000013902422709726699690_",
    d: "M706.768,378.533v10.331h-3.252v-9.958c0-3.524-1.762-5.249-4.846-5.249-3.454,0-5.69,2.07-5.69,5.962v9.246h-3.252V370.91h3.114v2.709a7.684,7.684,0,0,1,6.468-2.88c4.381,0,7.457,2.507,7.457,7.793",
    transform: "translate(-640.998 -365.157)",
    fill: "#171f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79776_00000013188764374670843390000014176691026332612511_",
    d: "M742.891,378.031v10.837h-3.084V386.5c-1.086,1.623-3.084,2.576-5.893,2.576-4.062,0-6.638-2.167-6.638-5.286,0-2.879,1.863-5.249,7.213-5.249h5.147V377.9c0-2.741-1.592-4.332-4.812-4.332a9.073,9.073,0,0,0-5.69,1.932l-1.352-2.438a11.958,11.958,0,0,1,7.415-2.3c4.913,0,7.691,2.368,7.691,7.276m-3.252,5.355v-2.507h-5.015c-3.215,0-4.13,1.256-4.13,2.779,0,1.794,1.49,2.912,3.96,2.912a5.212,5.212,0,0,0,5.185-3.183",
    transform: "translate(-658.561 -365.16)",
    fill: "#171f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79777_00000109740308610099488230000015194550962610040243_",
    d: "M780.663,370.912V386.42c0,6.335-3.22,9.214-9.315,9.214-3.284,0-6.608-.915-8.57-2.678l1.559-2.507a10.974,10.974,0,0,0,6.909,2.337c4.232,0,6.167-1.964,6.167-6.031v-1.421a8.205,8.205,0,0,1-6.468,2.778c-5.185,0-9.113-3.524-9.113-8.7s3.928-8.671,9.113-8.671a8.192,8.192,0,0,1,6.638,2.949v-2.78Zm-3.183,8.5c0-3.487-2.576-5.823-6.167-5.823-3.62,0-6.2,2.337-6.2,5.823,0,3.454,2.576,5.86,6.2,5.86,3.587-.005,6.167-2.406,6.167-5.86",
    transform: "translate(-674.722 -365.154)",
    fill: "#171f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79778_00000113323712686485272670000001176223944245941417_",
    d: "M820.371,380.974H805.807c.4,3.151,2.948,5.248,6.5,5.248a6.735,6.735,0,0,0,5.185-2.167l1.794,2.1a9.012,9.012,0,0,1-7.079,2.912c-5.791,0-9.65-3.827-9.65-9.177a8.791,8.791,0,0,1,9.006-9.145c5.179,0,8.873,3.726,8.873,9.246-.005.266-.037.67-.069.979M805.8,378.633h11.519a5.8,5.8,0,0,0-11.519,0",
    transform: "translate(-693.771 -365.161)",
    fill: "#171f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79779_00000142135239812502407770000011953114073591596190_",
    d: "M852.128,383.958l-7.111-9.789-7.01,9.789h-3.9l8.9-12.157-8.37-11.551H838.5l6.638,9.113,6.569-9.113H855.4l-8.37,11.445,8.975,12.261Z",
    transform: "translate(-703.628 -359.995)",
    fill: "#171f32"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41155",
    "data-name": "Group 41155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39951",
    "data-name": "Group 39951",
    transform: "translate(6.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39950",
    "data-name": "Group 39950",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1210",
    "data-name": "Rectangle 1210",
    width: 40.325,
    height: 23.419,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39953",
    "data-name": "Group 39953",
    transform: "translate(27.97 0.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39952",
    "data-name": "Group 39952",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1211",
    "data-name": "Rectangle 1211",
    width: 24.644,
    height: 28.479,
    transform: "translate(0 0.001)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39955",
    "data-name": "Group 39955",
    transform: "translate(16.94 16.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39954",
    "data-name": "Group 39954",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1212",
    "data-name": "Rectangle 1212",
    width: 18.736,
    height: 12.386,
    transform: "translate(0 -0.001)",
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39957",
    "data-name": "Group 39957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39956",
    "data-name": "Group 39956",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1213",
    "data-name": "Rectangle 1213",
    width: 24.644,
    height: 28.478,
    fill: "url(#linear-gradient-8)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/LogoBlack.06c175e3ff74a5b8724ff8e853b9ac85.svg";
export { ForwardRef as ReactComponent };